export type Trend = "up" | "down" | "flat";

export interface HotItem {
  id: number;
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: Trend;
  delta: string;
}

export interface LeakItem {
  id: number;
  title: string;
  summary: string;
  source: string;
  tag: string;
  time: string;
  image: string;
  view: string;
}

export interface MelonReview {
  id: number;
  name: string;
  tagline: string;
  subject: string;
  image: string;
  stage: number; // current progress stage index
  stageName: string;
  stages: string[];
  heat: string;
  parties: string[];
}

export interface AggItem {
  id: number;
  platform: string;
  handle: string;
  title: string;
  summary: string;
  time: string;
  reactions: string;
}

export interface ExpressItem {
  id: number;
  keyword: string[];
  title: string;
  time: string;
  source: string;
  isNew: boolean;
}

export interface KeywordItem {
  name: string;
  weight: number; // 1..5
  hot: boolean;
}

export const heroStats = [
  { label: "今日新料", value: "36+" },
  { label: "正在发酵的大瓜", value: "09" },
  { label: "覆盖平台源", value: "18" },
];

export const hotList: HotItem[] = [
  { id: 1, rank: 1, title: "剧组深夜密会：一线男星与神秘女子同车返沪", category: "剧组", heat: 9824, trend: "up", delta: "+18.2%" },
  { id: 2, rank: 2, title: "当红女团演唱会结束后，成员包厢夜谈画面流出", category: "团体", heat: 9416, trend: "up", delta: "+12.7%" },
  { id: 3, rank: 3, title: "选秀出道小生被曝与经纪人长期共用住所", category: "恋情", heat: 8890, trend: "up", delta: "+9.4%" },
  { id: 4, rank: 4, title: "导演开新综，常驻名单疑含已息影多年的影后", category: "综艺", heat: 8102, trend: "up", delta: "+6.1%" },
  { id: 5, rank: 5, title: "顶流代言商同日发两条秒删微博引猜测", category: "商务", heat: 7690, trend: "flat", delta: "+0.3%" },
  { id: 6, rank: 6, title: "某音乐节压轴名单曝光，粉丝阵营吵翻天", category: "演出", heat: 7233, trend: "up", delta: "+5.6%" },
  { id: 7, rank: 7, title: "热搜常客时隔三年直播首秀，弹幕刷屏", category: "直播", heat: 6941, trend: "up", delta: "+4.8%" },
  { id: 8, rank: 8, title: "IP 大剧换角风波再添新料，原定主演深夜发声", category: "影视", heat: 6550, trend: "down", delta: "-1.2%" },
  { id: 9, rank: 9, title: "校园剧新晋小花被拍到与制作人同逛书店", category: "恋情", heat: 6124, trend: "up", delta: "+3.9%" },
  { id: 10, rank: 10, title: "前辈主持谈新人评奖争议，一句话引爆评论区", category: "综艺", heat: 5798, trend: "flat", delta: "+0.1%" },
  { id: 11, rank: 11, title: "男团回归预告卡点诡异，网友扒出隐藏行程", category: "团体", heat: 5342, trend: "down", delta: "-2.3%" },
  { id: 12, rank: 12, title: "悬疑剧编剧开撕剪辑师，剧未播先出「内部版本」瓜", category: "影视", heat: 4980, trend: "up", delta: "+2.0%" },
];

export const topTags = [
  { name: "热度", key: "heat", active: true },
  { name: "讨论量", key: "discuss", active: false },
  { name: "新增爆料", key: "new", active: false },
];

export const leakList: LeakItem[] = [
  {
    id: 1, title: "选秀一哥签约去向有变？原公司解约条款疑被提前触发",
    summary: "多方渠道指向其与平台方洽谈新约，粉丝后援会连夜开会站队，相关词条已连续三日挂在讨论前列。",
    source: "微博 · 娱记阿明", tag: "签约", time: "12 分钟前", view: "26.3w", image: "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20screen%20flooded%20with%20rapidly%20incoming%20social%20notifications%2C%20warm%20amber%20glow%2C%20moody%20low%20light%2C%20editorial%20magazine%20photography%2C%20shallow%20depth%20of%20field%2C%20press%20buzz%20atmosphere&width=640&height=420&seq=kl-leak-01&orientation=landscape",
  },
  {
    id: 2, title: "当红女星新剧路透被指剧本魔改，原著粉集体声讨",
    summary: "一组片场偷拍对比原著时间线，核心人设改动遭书粉贴出细节逐条反驳，剧组方暂未正面回应。",
    source: "豆瓣 · 原著组", tag: "影视", time: "38 分钟前", view: "19.8w", image: "https://readdy.ai/api/search-image?query=an%20open%20film%20script%20notebook%20with%20handwritten%20notes%20and%20a%20coffee%20cup%20on%20a%20wooden%20table%2C%20warm%20cinematic%20film%20set%20lighting%2C%20candid%20behind%20the%20scenes%20editorial%20photography%2C%20soft%20shadows%20and%20muted%20warm%20tones&width=640&height=420&seq=kl-leak-02&orientation=landscape",
  },
  {
    id: 3, title: "综艺节目预告里一闪而过的身影，被认出是顶流歌手",
    summary: "三秒画面逐帧慢放比对同款造型，评论弹幕瞬间爆满，官方账号涨粉速度肉眼可见地加快。",
    source: "B站 · 饭拍站", tag: "综艺", time: "1 小时前", view: "31.4w", image: "https://readdy.ai/api/search-image?query=stage%20lights%20and%20television%20show%20set%20with%20dramatic%20warm%20spotlights%2C%20empty%20studio%20backdrop%2C%20behind%20the%20scenes%20photography%2C%20hazy%20atmosphere%20and%20glowing%20bokeh%2C%20editorial%20and%20cinematic&width=640&height=420&seq=kl-leak-03&orientation=landscape",
  },
  {
    id: 4, title: "双女主悬疑剧开机仅半月，导演深夜取关主演账号",
    summary: "开机宴合影早已删除，同组配角也相继取关，网友顺着蛛丝马迹扒出开机发布会两人全程零交流。",
    source: "贴吧 · 剧组吧", tag: "剧组", time: "1 小时前", view: "23.1w", image: "https://readdy.ai/api/search-image?query=film%20crew%20director%20chair%20and%20clapperboard%20on%20a%20dramatic%20empty%20set%2C%20warm%20theater%20lighting%2C%20tense%20mood%2C%20behind%20the%20scenes%20editorial%20photography%2C%20soft%20shadows%20and%20amber%20tones&width=640&height=420&seq=kl-leak-04&orientation=landscape",
  },
  {
    id: 5, title: "顶流男团演唱会黄牛票跌破原价，主办方被质疑放水",
    summary: "二手平台大量出票信息刷屏，此前一票难求的话题词热度骤降，圈内开始猜测是否有大批团票回流。",
    source: "抖音 · 现场派", tag: "演出", time: "2 小时前", view: "17.6w", image: "https://readdy.ai/api/search-image?query=concert%20tickets%20and%20phone%20flashlight%20glow%20at%20a%20large%20auditorium%2C%20warm%20stage%20bokeh%20in%20background%2C%20candid%20crowd%20photography%2C%20moody%20amber%20lighting%2C%20editorial%20magazine%20style&width=640&height=420&seq=kl-leak-05&orientation=landscape",
  },
  {
    id: 6, title: "演员副业餐饮品牌再关一店，加盟商维权群聊流出",
    summary: "门店定位显示转让中，多位加盟商在群里晒出聊天记录讨论押金与装修款，品牌官方尚无公告。",
    source: "小红书 · 探店号", tag: "副业", time: "3 小时前", view: "14.9w", image: "https://readdy.ai/api/search-image?query=restaurant%20storefront%20with%20closed%20sign%20and%20barred%20door%20at%20dusk%2C%20warm%20street%20lamps%2C%20slightly%20melancholy%20editorial%20photography%2C%20film%20noir%20warm%20tone%2C%20quiet%20night%20street%20atmosphere&width=640&height=420&seq=kl-leak-06&orientation=landscape",
  },
];

export const melonReviews: MelonReview[] = [
  {
    id: 1,
    name: "顶流直播翻车",
    tagline: "从控评翻车到全员下场，一周吃完一整颗瓜",
    subject: "直播 · 顶流",
    image: "https://readdy.ai/api/search-image?query=overflowing%20red%20curtains%20and%20scattered%20newspapers%20with%20headline%20cutouts%20on%20a%20warm%20desk%2C%20dramatic%20editorial%20collage%20style%2C%20vintage%20magazine%20cover%20aesthetic%2C%20warm%20red%20and%20amber%20lighting%2C%20cinematic%20still%20life&width=720&height=500&seq=kl-melon-01&orientation=landscape",
    stage: 3,
    stageName: "收束",
    stages: ["起爆", "发酵", "实锤", "收束"],
    heat: "9.8w 讨论",
    parties: ["当事人 · 平台 · 品牌方"],
  },
  {
    id: 2,
    name: "女星解约风波",
    tagline: "一条隐藏定位，牵出近半年的合约暗流",
    subject: "商务 · 解约",
    image: "https://readdy.ai/api/search-image?query=legal%20contract%20documents%20with%20seal%20and%20signature%20pen%20arranged%20on%20warm%20desk%2C%20soft%20window%20light%2C%20editorial%20photography%20with%20shallow%20focus%2C%20serious%20corporate%20mood%2C%20warm%20neutral%20tones&width=720&height=500&seq=kl-melon-02&orientation=landscape",
    stage: 2,
    stageName: "实锤",
    stages: ["起爆", "发酵", "实锤", "收束"],
    heat: "7.2w 讨论",
    parties: ["艺人方 · 老东家 · 新平台"],
  },
  {
    id: 3,
    name: "剧组换角罗生门",
    tagline: "开机前 40 天，男主从官宣到被换只用两天",
    subject: "影视 · 换角",
    image: "https://readdy.ai/api/search-image?query=drama%20set%20clapperboard%20with%20paper%20cutouts%20and%20question%20marks%20on%20a%20warm%20backstage%20desk%2C%20moody%20editorial%20still%20life%2C%20mysterious%20atmosphere%2C%20warm%20amber%20lighting%2C%20film%20production%20theme&width=720&height=500&seq=kl-melon-03&orientation=landscape",
    stage: 1,
    stageName: "发酵",
    stages: ["起爆", "发酵", "实锤", "收束"],
    heat: "6.1w 讨论",
    parties: ["男主 · 出品方 · 原导演"],
  },
];

export const platformFeed: { platform: string; count: string; icon: string }[] = [
  { platform: "微博热搜", count: "1.2w+", icon: "ri-weibo-fill" },
  { platform: "豆瓣小组", count: "3800+", icon: "ri-book-2-fill" },
  { platform: "抖音热榜", count: "9400+", icon: "ri-music-2-fill" },
  { platform: "小红书", count: "2600+", icon: "ri-sparkling-2-fill" },
  { platform: "贴吧", count: "1500+", icon: "ri-chat-3-fill" },
  { platform: "B站", count: "4700+", icon: "ri-play-circle-fill" },
];

export const aggList: AggItem[] = [
  { id: 1, platform: "微博", handle: "@热门榜", title: "某艺人经纪人深夜清空评论区，粉丝反转为新剧预热", summary: "账号活跃度异常带动相关话题冲榜。", time: "5 分钟前", reactions: "转 1.2w" },
  { id: 2, platform: "豆瓣", handle: "吃瓜日报组", title: "编剧亲自下场逐条回应「删改」争议，贴出原始大纲", summary: "原始稿件时间戳与爆料人说法对不上。", time: "14 分钟前", reactions: "赞 6600" },
  { id: 3, platform: "抖音", handle: "@现场记者派", title: "路透：剧组暂停夜戏拍摄，男女主各自补妆回房车", summary: "现场视频定位与网传行程高度吻合。", time: "22 分钟前", reactions: "评 3200" },
  { id: 4, platform: "小红书", handle: "@综艺显微镜", title: "慢综艺切片：两位嘉宾的站位，暴露了真实关系", summary: "三处同框站位分析被剪成二创长视频。", time: "36 分钟前", reactions: "藏 8900" },
  { id: 5, platform: "贴吧", handle: "剧组情报站", title: "群演晒出当日通告单，疑证实网传「开机跳票」说法", summary: "通告单关键字段被打码，仍引发比对潮。", time: "48 分钟前", reactions: "回 2100" },
  { id: 6, platform: "B站", handle: "UP主·娱论", title: "十分钟复盘：一颗瓜是如何从预告走向全员下场的", summary: "UP 主讲清时间线与反转节点，播放破百万。", time: "1 小时前", reactions: "投币 5.4w" },
];

export const expressList: ExpressItem[] = [
  { id: 1, keyword: ["顶流", "行程"], title: "顶流工作室放出新行程，评论区秒懂是为回应前日爆料", time: "刚刚", source: "官方 · 行程", isNew: true },
  { id: 2, keyword: ["综艺", "常驻"], title: "新综拟邀名单再添一人，被指「补偿式」官宣", time: "4 分钟前", source: "微博 · 营销号", isNew: true },
  { id: 3, keyword: ["影视", "选角"], title: "年度古装大剧开启线下选角试镜，网传条件苛刻引热议", time: "9 分钟前", source: "贴吧 · 剧组吧", isNew: true },
  { id: 4, keyword: ["团体", "物料"], title: "男团释出两版预告封面，被指呼应解散传闻", time: "15 分钟前", source: "官博", isNew: false },
  { id: 5, keyword: ["恋情", "路透"], title: "狗仔预告「周五见」，放出的剪影被锁定位出演男主", time: "23 分钟前", source: "狗仔 · 预告", isNew: false },
  { id: 6, keyword: ["直播", "带货"], title: "明星带货翻车后首播，全程回避相关词却被弹幕刷屏", time: "31 分钟前", source: "抖音 · 直播间", isNew: false },
  { id: 7, keyword: ["颁奖", "现场"], title: "颁奖礼台下抓拍走红：两位视后同框咬耳热聊", time: "42 分钟前", source: "微博 · 现场", isNew: false },
  { id: 8, keyword: ["商务", "代言"], title: "某护肤品牌连夜撤下顶流置顶物料，疑似解约前兆", time: "50 分钟前", source: "小红书 · 商业报", isNew: false },
  { id: 9, keyword: ["音乐", "新歌"], title: "歌手新歌采样被发现「撞」了已故曲作者旧作", time: "1 小时前", source: "B站 · 扒谱", isNew: false },
  { id: 10, keyword: ["家庭", "剧照"], title: "家庭剧放全家福宣传照，官方点名未出演的小演员", time: "1 小时前", source: "官博 · 宣传", isNew: false },
];

export const keywords: KeywordItem[] = [
  { name: "周五见", weight: 5, hot: true },
  { name: "行程" , weight: 4, hot: true },
  { name: "换角", weight: 5, hot: true },
  { name: "解约", weight: 4, hot: true },
  { name: "二创", weight: 3, hot: false },
  { name: "站位", weight: 3, hot: false },
  { name: "直播翻车", weight: 5, hot: true },
  { name: "试镜", weight: 2, hot: false },
  { name: "预告", weight: 3, hot: false },
  { name: "路透", weight: 4, hot: true },
  { name: "解散传闻", weight: 4, hot: true },
  { name: "物料", weight: 2, hot: false },
  { name: "收视", weight: 2, hot: false },
  { name: "澄清", weight: 3, hot: false },
  { name: "团票", weight: 2, hot: false },
  { name: "控评", weight: 3, hot: false },
  { name: "通告单", weight: 3, hot: false },
  { name: "后台", weight: 2, hot: false },
  { name: "代言", weight: 3, hot: false },
  { name: "开拍", weight: 2, hot: false },
];